import type { FC } from 'react';
import { ProsConsLists } from '@/components/hub/ProsConsLists';
import { Pages2Icon as Pages } from '@/components/icons/Pages2Icon';
import { useCopyCode } from '@/hooks/useCopyCode.hook';
import type { BonusOfferCons, BonusOfferPros } from '@/types/bookmaker';
import MarkdownContent from '../MarkdownContent';
import { HubSectionTitle } from './SectionTitle';

interface BonusSectionProps {
  title: string;
  text: string;
  pros: BonusOfferPros;
  cons: BonusOfferCons;
  value: string;
  valueDescription: string;
  code: string;
}

export const BonusSection: FC<BonusSectionProps> = ({
  title,
  text,
  pros,
  cons,
  value,
  valueDescription,
  code,
}) => {
  const { copyCode } = useCopyCode(code);
  return (
    <div
      className="flex flex-col gap-3 rounded-lg bg-medium-gray p-4"
      id="bonus"
    >
      <HubSectionTitle>{title}</HubSectionTitle>
      <div className="flex flex-row flex-wrap gap-2">
        <div
          className="flex h-[80px] min-w-[150px] flex-col items-start justify-center rounded-lg bg-cover p-2"
          style={{ backgroundImage: "url('/assets/offer_1x.webp')" }}
        >
          <p
            className="mb-0 font-semibold text-3xl"
            style={{ marginBottom: '0px' }}
          >
            {value}
          </p>
          <p className="text-xs">{valueDescription}</p>
        </div>
        <div className="flex h-[80px] w-[150px] flex-row gap-1 rounded-lg bg-component-bg px-1.5 py-4">
          <Pages
            className="h-[20px] w-[20px]"
            desc="Copy code icon"
            title="Copy Code"
          />
          <button
            className="w-[115px] cursor-pointer font-normal text-gray text-xs leading-4"
            onClick={copyCode}
            type="button"
          >
            Copy code and get an additional welcome gift
          </button>
        </div>
      </div>
      <MarkdownContent>{text ?? ''}</MarkdownContent>
      <ProsConsLists cons={cons} pros={pros} />
    </div>
  );
};
